import React, {Component} from 'react';
import { withRouter } from "react-router-dom";






class ClaimsDoc extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Claims </h2>

                 <p className='text-primary'>

                The Claims screen displays all the individuals or guests that have claimed to have lost an item or have been matched with a lost and found item.  
                The screen is divided into three major sections. The filter section along the top. The search section right below. And the grid to display all of the claims within the system. The claims grid is searchable filterable and sortable.
               
                </p>
               
                <br/>
               

                <h6> Using the Claims Screen </h6>
                <p className='text-primary'>


                 </p>
              
                <br/><br/><br/>
                <div className="text-center">
                <img className='text-center' style={{width:"80%", height:"80%"}} src='./images/claims.png'  alt=''/> 
              
                   
                </div>
               
              <p className='text-primary'>
                    <h6>Filtering:</h6>
                    Click the filter buttons along the top to auto-filter the list.  Selecting a filter will only show items in the list that pertain to matching that filter.  For example, click "Not Found".  This will dusplay
                    all claims from guests that have indicated that they have lost an item in the hotel but hasn't been found.

                       <br/><br/>
                    <h6>Searching:</h6>
                    Entering search criteria will auto-search the list and match on any field in the table.  The list will feature upon entering the first character and attempt to match that search criteria in the list.
                       <br/><br/>
                    <h6>Sorting:</h6>
                    Clicking on the column headers will sort ASC/DESC for any of the supported columns.  
                    <br/><br/>
                    <h6>Pagination:</h6>
                    The Claims items will default to 10 items. Locate the pagination button toward the bottom left-hand of the screen. Here you adjust how many items to display.  You can select the page, previous, and next pages 
                    by clicking the lower-right menu items.

    
                </p>
                
            </div>
        )
       


    }

}
export default withRouter(ClaimsDoc);
